import React, { useState } from 'react';
import { fetchApiData } from '../Utils/ApiCalls';
import { ATTACH_PLAN_ENDPOINT } from '../urls';
import useFormStatus from '../Hooks/useFormStatus';
import { Alert } from './Alert';
import { Button } from '@attentive-platform/stem-ui';

const ProConversionForm = () => {
  const [email, setEmail] = useState('');

  const { successMessage, errorMessage, handleApiResult } = useFormStatus();

  const handleSubmit = async e => {
    e.preventDefault();

    // Create an object with the form data
    const formData = {
      email: email.toLowerCase()
    };
    // Make the POST request to the API with the form data
    const response = await fetchApiData({
      endpoint: ATTACH_PLAN_ENDPOINT,
      data: formData
    });

    handleApiResult(response);
    setEmail('');
  };
  return (
    <form onSubmit={handleSubmit} className='w-100'>
      <Alert errorMessage={errorMessage} successMessage={successMessage} />
      <div className='input-group mb-3'>
        <input
          type='Email'
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          className='form-control form-control-lg'
          placeholder='Email'
          aria-label='Email'
        />
      </div>
      <div className='button'>
        <Button color='primary' size='large' variant='contained' type='submit'>
          Add to PRO plan
        </Button>
      </div>
    </form>
  );
};
export default ProConversionForm;
